export const HOME_HERO_REQUEST = 'HOME_HERO_REQUEST'
export const HOME_HERO_SUCCESS = 'HOME_HERO_SUCCESS'
export const HOME_HERO_FAIL    = 'HOME_HERO_FAIL'
